import { Accordion, AccordionItem }  from 'components/_UI/Accordion'
import Text from 'components/_UI/Text'
import React from 'react'
import { Edit, Trash2 } from 'lucide-react'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import { Row } from 'styled/alignment/Row'
import breakpoints from 'theme/breakpoints'
import colors from 'theme/colors'


export default function FaqList({faq, action}) {
  return (
    <>
      <Container>
        {
          faq?.map(item => (

            <Accordion>
             
                <AccordionItem id={item.id} header={<TextQuestion>{item.question}</TextQuestion>}>
                  <Column>
                    <StyledAccordion>

                      <TextQuestion answer>{item.answer}</TextQuestion>
                      {
                        action &&
                        <StyledActions>
                          <ContentIcon onClick={
                            () => action({
                              item: item,
                              type: 'deleteFaq'
                            })}
                          >
                            <Trash2 color={colors.danger}  size={20}/>
                          </ContentIcon>

                          <ContentIcon onClick={
                            () => action({
                              item: item,
                              type: 'editFaq'
                            })}
                          >
                            <Edit color={colors.primaryLight} size={20}/>
                          </ContentIcon>
                        </StyledActions>
                      }
                    </StyledAccordion>
                  </Column>
                </AccordionItem>
              
            </Accordion>
            ))
          }
        
      </Container>
    
    </>
  )
}

const Container = styled(Column)`
    width: 100%;    
    gap: 2px;

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        gap: 2px;
        flex-wrap: wrap;
    }
`

const StyledAccordion = styled(Row)`
  width: 100%;
  justify-content: space-between;
  & > svg {
    cursor: pointer;
  }
`;

const ContentIcon = styled.div`
  cursor: pointer;
`;


const StyledActions = styled(Row)`
  justify-content: space-between;
  width: 5%;
`;

const TextQuestion = styled.p`
 

  ${({answer}) => answer && `
    font-size: 14px;
    color: ${colors.nightLight};
  `}
`

